export default __webpack_public_path__ + "static/media/skill_latex.731d618b.png";